// extracted by mini-css-extract-plugin
module.exports = {"container":"SetupNotifications_container__1Q0Oc","row":"SetupNotifications_row__346nt"};